import { __assign } from "tslib";
import React, { useEffect, useRef, useState } from 'react';
import classnames from 'classnames';
import { Helmet } from 'react-helmet-async';
import { isDeviationPixelArt, isFileLargerThanSize, } from '../../../DeviationViews/_helpers';
import { getSrcSet } from '../../../DeviationViews/Dumbo/Image/_helpers';
import MediaService from '../../../utils/DeviationMediaService';
import ContentShadow from '../_partials/ContentShadow';
import ImageContent from './ImageContent';
import ZoomModal from './ZoomModal';
import { useDeviationViewContext } from '../../../Context';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import ddt from '@wix/da-ddt';
import { useSelector } from 'react-redux';
import { getIsDuperbrowseActive } from '../../../Duperbrowse/redux/selectors';
// eslint-disable-next-line @wix/da/scss-same-filename-as-module
import s from './Image.scss';
export var MobileImageFullView = function (_a) {
    var _b;
    var width = _a.width, height = _a.height, deviation = _a.deviation, isZoomed = _a.isZoomed, onEnterZoomMode = _a.onEnterZoomMode, onExitZoomMode = _a.onExitZoomMode;
    var lcp2 = useFlag('lcp2'); // use thumb not fullview
    var isDuperbrowse = useSelector(function (state) { return getIsDuperbrowseActive(state); });
    var isFullscreen = useDeviationViewContext().isFullscreen;
    var isPixel = isDeviationPixelArt(deviation);
    var zoomedFile = MediaService.getLargestFullview(deviation);
    var isBiggerThanStage = !!zoomedFile && // must have a fullview
        !MediaService.isGif(deviation) && // must not be a gif as selecting sized one will give you static jpg sometimes
        isFileLargerThanSize(zoomedFile, width, height); // must be larger than the artstage
    var file;
    // Duperbrowse uses the fullview always
    if (isDuperbrowse) {
        file = isBiggerThanStage
            ? MediaService.getFullviewForSize(deviation, isZoomed ? 0 : width, isZoomed ? 0 : height)
            : zoomedFile;
    }
    // Canonical uses mobile/small screen selection logic to get the smallest
    // thumb for the artstage but still respect gifs etc
    if (lcp2 && !isDuperbrowse) {
        file = isBiggerThanStage
            ? MediaService.getSmallestThumbForArtStage(deviation, width || 360, height || 360)
            : zoomedFile;
    }
    // Add the srcset after the LCP has happened, the browser can then
    // deal with enhancing the image quality based on the device
    var _c = useState(false), withSrcSet = _c[0], setWithSrcSet = _c[1];
    var upgraded = useRef(false);
    useEffect(function () {
        var upgradeImage = function () {
            if (file && !upgraded.current) {
                upgraded.current = true;
                setWithSrcSet(true);
            }
        };
        if (!isDuperbrowse) {
            window.addEventListener('load', upgradeImage);
        }
        return function () {
            if (!isDuperbrowse) {
                window.removeEventListener('load', upgradeImage);
            }
        };
    }, [file, isDuperbrowse, lcp2]);
    if (!file) {
        return null;
    }
    ddt.log('deviation', 'USING FILE', file);
    ddt.log('deviation', 'ZOOM', isZoomed, zoomedFile);
    return (React.createElement("div", { className: classnames(s['root'], isFullscreen && s['fullscreen']), style: { width: width, height: height } },
        React.createElement(Helmet, null,
            React.createElement("link", __assign({ rel: "preload", href: file.src, as: "image" }, { fetchpriority: 'high' }))),
        isZoomed && zoomedFile && (React.createElement(ZoomModal, { src: zoomedFile.src, srcSet: getSrcSet(deviation), width: zoomedFile.width, height: zoomedFile.height, isPixel: isPixel, onClose: onExitZoomMode })),
        React.createElement(ContentShadow, { content: file, containerSize: { width: width, height: height }, useSmallStage: true, className: s['shadow'] },
            React.createElement(ImageContent, { key: file.src, width: width, height: height, file: file, alt: (_b = deviation.title) !== null && _b !== void 0 ? _b : '', isPixel: isPixel, canZoom: isBiggerThanStage, onZoom: onEnterZoomMode, withSrcSet: withSrcSet }))));
};
MobileImageFullView.displayName = 'MobileImageFullView';
export default MobileImageFullView;
//# sourceMappingURL=MobileImage.js.map